import { IconProps } from './iconTypes';

export const Download = ({ color, ...props }: IconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        height="24px"
        width="24px"
        fill={color}
        {...props}
    >
        <g>
            <rect fill="none" height="24" width="24" />
        </g>
        <g>
            <path d="M19,9h-4V3H9v6H5l7,7L19,9z M5,18v2h14v-2H5z" />
        </g>
    </svg>
);
